<ng-template
  *ngTemplateOutlet="filter(); context:{$implicit:dt }"
></ng-template>
<p-table
  #dt
  [value]="inputData() ? inputData()!.slice($getTable.first(), $getTable.first() + $getTable.rows()) : $getTable.dataSet()"
  (onLazyLoad)="$getTable.loadData($event)"
  [showCurrentPageReport]="true"
  [lazy]="inputData() ? false: true"
  [rows]="$getTable.rows()"
  [first]="$getTable.first()"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template #header>
    <tr>
      <th>No</th>
      @if(actionColumn()) {
      <th *uiPermission="permissions()">
        {{actionColumnHeader() | transloco}}
      </th>
      } @for (item of column(); track $index) {
      @if (item.sortable === false) {
      <th>{{item.header | transloco}}</th>
      } @else {
      <th [pSortableColumn]="$any(item.field)">
        {{item.header | transloco}}
        <i class="pi pi-code rotate-90 text-[#94A3B8]"></i>
      </th>
      }
      }
    </tr>
  </ng-template>
  <ng-template #body let-data let-rowIndex="rowIndex">
    <tr>
      @if ($getTable.isLoading()) {
      <td><p-skeleton /></td>
      @if (actionColumn()) {
      <td>
        <p-skeleton />
      </td>
      } @for (item of column(); track $index) {
      <td>
        <p-skeleton />
      </td>
      } } @else {
      <td>{{$getTable.first()+rowIndex+1}}</td>
      @if(actionColumn()) {
      <td *uiPermission="permissions()">
        <ng-template
          *ngTemplateOutlet="actionColumn();context:{$implicit:data,} "
        ></ng-template>
      </td>
      } @for (item of column(); track $index) {
      <td>
        @if (item?.template==='custom') {
        <ng-template
          *ngTemplateOutlet="customColumn(); context:{$implicit:data, item:item }"
        ></ng-template>
        } @else if(item?.isMultilanguage) { {{ data[item.field] |
        languagePipe:item?.lang | async }} } @else if (item.template==='date') {
        {{data[item.field] | date:'dd.MM.yyyy'}}         } @else if (item.fractionDigits
        != null) { {{ data[item.field] | tableNumberFormat:item.fractionDigits }}
        } @else { {{ data[item.field] | tableNumberFormat }} }
      </td>
      } }
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td colspan="100">
        <div
          class="w-full flex justify-center text-[20px] h-[200px] items-center gap-3"
        >
          <p class="font-semibold">{{'No_data' | transloco}}</p>
          <i class="pi pi-server !text-[30px]"></i>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<div class="w-full flex justify-between items-center">
  <!-- <p class="text-[#94A3B8] text-[14px] font-medium">
    {{'pagination_showing' | transloco: { start: first() + 1, end: first() + 10,
    total: totalRecords() } }}
  </p> -->
  <p class="text-[#94A3B8] text-[14px] font-medium">
    {{ (inputData()?.length ?? $getTable.totalRecords()) > 0 ? $getTable.first()
    + 1 : 0 }} / {{ inputData()?.length ?? $getTable.totalRecords() }}
  </p>
  <p-paginator
    styleClass="!bg-transparent !px-0"
    [first]="$getTable.first()"
    [rows]="$getTable.rows()"
    (onPageChange)="$getTable.first.set($event.first || 0); !inputData() && $getTable.loadData()"
    [totalRecords]="inputData()?.length ?? $getTable.totalRecords()"
  ></p-paginator>
</div>
